// extracted by mini-css-extract-plugin
export default {"documentListContainer":"document-list_documentListContainer__WcbSb"};